import { apiPost } from '../../api'

export const save_calendar = data => {
  return apiPost({
    endpoint: 'curriculums/save_calendar',
    data
  })
}
